import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ICON_PATHS } from "./icons.js";
const SIZE_PX = {
    xs: 14,
    sm: 16,
    md: 20,
    lg: 24,
};
/**
 * Single outline icon language for the whole design system: 24x24 grid,
 * constant 1.5px stroke, round caps/joins, no fills, inherits currentColor.
 * Never mix this with icons from another library or stroke weight.
 */
export function Icon({ name, size = "md", strokeWidth = 1.5, title, className = "", ...rest }) {
    const px = typeof size === "number" ? size : SIZE_PX[size];
    const path = ICON_PATHS[name];
    return (_jsxs("svg", { viewBox: "0 0 24 24", width: px, height: px, fill: "none", stroke: "currentColor", strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round", className: `nbs-icon ${className}`.trim(), role: title ? "img" : "presentation", "aria-hidden": title ? undefined : true, "aria-label": title, ...rest, children: [title ? _jsx("title", { children: title }) : null, _jsx("path", { d: path })] }));
}
//# sourceMappingURL=Icon.js.map